export default __webpack_public_path__ + "static/media/location.339e2878.svg";